module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Wallet3-d55955a13d00c0b0db25b806003bc708.svg";